export const EN_US = 'en-US'
export const ES_MX = 'es-MX'
